// test-events.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TestEventsService {
  private newTestCreatedSource = new Subject<any>();
  newTestCreated$ = this.newTestCreatedSource.asObservable();

  emitNewTestCreated(test: any) {
    this.newTestCreatedSource.next(test);
  }
}
